import { Component, OnInit } from '@angular/core';
import { UtilService } from 'app/shared/util.service';
import { Hotel } from 'app/shared/model';
import { DateService } from 'app/shared/services/date.service';
import { Router } from '@angular/router';

@Component({
    selector: 'mh-followup-executive-section',
    templateUrl: './followup-executive.component.html',
    styleUrls: ['./followup-executive.component.scss'],
    standalone: false
})
export class FollowupExecutiveSectionComponent implements OnInit {
  productId = 1;

  filters = [
    'nps',
    'area',
    'sent_emails',
    'email_rate',
    'rate',
    'answered',
    'email_surveys',
    'open_surveys',
    'semantic_positive',
    'semantic_negative',
    'semantic_index',
  ];

  metricsActions: { [key: string]: string } = {
    nps: 'getHistoricNPS',
    area: 'getHistoricArea',
    sent_emails: 'getEmailsArea',
    email_rate: 'getEmailsArea',
    rate: 'getEmailsArea',
    answered: 'getEmailsArea',
    email_surveys: 'getEmailsArea',
    open_surveys: 'getEmailsArea',
    semantic_positive: 'getSemanticIndex',
    semantic_negative: 'getSemanticIndex',
    semantic_index: 'getSemanticIndex',
  };

  fidelityPermisions: string[] = [];
  chain: Hotel[] = [];

  chainFilter: Hotel[] = [];
  originalChainFilter: Hotel[] = [];
  chainToReport: Hotel[] = [];
  report: string;

  filtersData = {};
  filterSelected = {};
  filtersTypes = [];
  filtersAreas = [];

  surveysReady = false;

  constructor(private utilService: UtilService, private dateService: DateService, private router: Router) {}

  ngOnInit(): void {
    this.getProductById();
    setTimeout(() => {
      this.chain = this.utilService.getInnerChain(false, 'followup');
    }, 0);
    this.fidelityPermisions = this.utilService.getFidelityConfigurationsByProduct('interchain', 'interchain_followup');
    this.report = this.productId === 1 ? 'chainFollowupExecutive' : 'chainOnsiteExecutive';
    this.initializeFilters();
  }

  private initializeFilters(): void {
    this.filtersData['metrics'] = this.metricsActions;
    this.filterSelected['metrics'] = this.filters[0];
    this.filtersTypes = ['metrics'];
  }

  onAreasAvailable(areas: number[]): void {
    const areasActions: { [key: number]: string } = {};
    areas.forEach(areaId => {
      areasActions[areaId] = `area_${areaId}`;
    });

    this.filtersAreas = areas;
    this.filterSelected['areas'] = areas[0];
    this.filtersData['areas'] = areasActions;
    if (!this.filtersTypes.includes('areas')) {
      this.filtersTypes.push('areas');
    }
  }

  setSelectValue($event: any, key: string): void {
    this.filterSelected = {
      ...this.filterSelected,
      [key]: $event.value,
    };

    if (key === 'metrics') {
      if ($event.value !== 'area') {
        this.filtersTypes = this.filtersTypes.filter(type => type !== 'areas');
        delete this.filterSelected['areas'];
        delete this.filtersData['areas'];
        this.filtersAreas = [];
      }
    }
  }

  setChain(chain: Hotel[]): void {
    setTimeout(() => {
      this.originalChainFilter = [...chain];
      this.chainFilter = [...chain];
    }, 0);
  }

  setHotelsFilter(hotels: Hotel[]): void {
    this.chainFilter = [...hotels];
  }

  setChainToReport($event: Hotel[]): void {
    this.chainToReport = $event;
  }

  getProductById() {
    this.productId = this.router.url.includes('followup') ? 1 : 2;
  }

  handleDatepickerUpdated($event) {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates);
  }

  get currentDates() {
    return this.dateService.currentDates;
  }

  get currentFilterDate() {
    return this.dateService.currentFilter;
  }

  get startDate() {
    return this.currentDates.startDate;
  }

  get endDate() {
    return this.currentDates.endDate;
  }

  get reportSlug() {
    return this.productId === 1 ? 'corporative_followup_ejecutive_report' : 'corporative_onsite_ejecutive_report';
  }

  onSurveysLoaded(): void {
    this.surveysReady = true;
  }
}
